import React, { useContext } from "react";
import { useProspectProfile } from "../../../contexts/ProsepctProfileContext";
import styled, { ThemeContext } from "styled-components";
import { Accordion, AccordionBody, AccordionHeader } from "best-common-react";
import { useTranslation } from "react-i18next";

const ProfileImg = styled.img`
  width: 500px;
  height: 500px;

  @media (max-width: 976px) {
    width: 300px;
    height: 300px;
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ProspectPhotoReadyOnly: React.FC = () => {
  const { profile } = useProspectProfile();
  const Theme = useContext(ThemeContext);
  const { t } = useTranslation("profile");

  return (
    <Accordion
      accordionKey="prospect-photo"
      styles={{ ...Theme.accordion, body: { ...Theme.accordion.body, background: Theme.colors.cloud, border: "none" } }}
    >
      <AccordionHeader>{t("profile:photoSection")}</AccordionHeader>
      <AccordionBody>
        <ImageContainer>
          {profile?.hasPhoto === true && <ProfileImg src={profile?.photoUrl} alt="Profile Picture" />}
        </ImageContainer>
      </AccordionBody>
    </Accordion>
  );
};

export default ProspectPhotoReadyOnly;
